import { Box, Stack, Typography } from '@mui/material';

export const EmptyCollectionListView = () => {
  return (
    <Stack
      spacing={1}
      px={2}
      alignItems="center"
      justifyContent="center"
      height={250}
    >
      <Box fontSize="3rem">📁</Box>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        <Box>No Collections created yet.</Box>
        <Box>Click below to create your first one.</Box>
      </Typography>
    </Stack>
  );
};
